import { Flex, Spinner, Text, useColorModeValue } from "@chakra-ui/react";

const ContentLoader = ({
    label = "Loading...",
    minH = "120px",
    size = "md",
    showLabel = true,
    ...rest
}) => {
    const textColor = useColorModeValue("gray.500", "gray.300");

    return (
        <Flex
            align='center'
            justify='center'
            direction='column'
            minH={minH}
            w='100%'
            role='status'
            aria-live='polite'
            {...rest}>
            <Spinner color='teal.300' size={size} thickness='3px' speed='0.65s'/>
            {showLabel && (
                <Text mt='10px' fontSize='sm' color={textColor} fontWeight='medium'>
                    {label}
                </Text>
            )}
        </Flex>
    );
};

export default ContentLoader;
